import classNames from 'classnames';
import React, { ReactElement, ReactNode, useMemo } from 'react';
import Button from '../../wui-button/src';
import {WebUI, getNid, prefix} from "../../wui-core/src/index";
import Icon from '../../wui-icon/src';
import Dropdown from './index';
import { DropdownButtonProps} from './iDropdown';
import { ButtonIcon } from '../../wui-button/src/iButton';
import { useId } from '../../wui-core/src/reactCompat';
import { DropdownDefaultProps } from './Dropdown';

const ButtonGroup = Button.Group;

const DropdownButton = (props: DropdownButtonProps) => {
    const {
        clsPrefix,
        type = 'default',
        disabled = false,
        onClick,
        htmlType,
        children = <span />,
        className,
        trigger,
        href,
        fieldid,
        icon = <Icon fieldid='arrow_icon' type="uf-gridcaretdown"/>,
        title = '',
        buttonsRender = (buttons: React.ReactNode[]) => buttons,
        size,
        triggerType = 'button',
        style,
        id,
        // showAction = [],
        // hideAction = [],
        // minOverlayWidthMatchTrigger = true,
        // overlayClassName = '',
        // overlayStyle = {},
        overlay = '暂无数据',
        // placement = 'bottomLeft',
        // defaultVisible = false,
        // overlayMaxHeight = false,
        // destroyPopupOnHide = false,
        ...restProps
    } = props;

    const rootNodeId = useId();
    const [leftDisabled, rightDisabled] = Array.isArray(disabled) ? [...disabled] : [disabled, disabled];


    const {childs, overlayMenu} = useMemo(() => {
        let overlayNode: ReactElement | null = null;
	    if (Array.isArray(children)) {
	        const childs: ReactNode[] = children.reduce((preChilds, child) => {
	            if (!overlayNode && child?.props?.clsPrefix === `${prefix}-menu`) {
	                overlayNode = child;
	                return preChilds
	            }
	            if (child) {
	                return [...preChilds, child];
	            }
	            return preChilds
	        }, [])
	        return {childs, overlayMenu: overlayNode}
	    }
	    return {childs: children}
    }, [children]);

    const finalProps = {
        ...DropdownDefaultProps,
        ...restProps,
        overlay: overlayMenu || overlay
    };

    const leftButton = (
        <Button
            type={type}
            size={size}
            id={id}
            disabled={leftDisabled}
            onClick={onClick}
            htmlType={htmlType}
            href={href}
            title={title}
            fieldid={fieldid && `${fieldid}_btn`}
            className={`${clsPrefix}-left`}
            maxWidth={true}
            icon={triggerType === 'button' ? icon as ButtonIcon : undefined}
        >
            {childs}
        </Button>
    );

    const rightButton = <Button fieldid={fieldid && `${fieldid}_sub_btn`} disabled={rightDisabled} className={`${clsPrefix}-right`} size={size} type={type}
        icon={icon as ButtonIcon}/>;

    let [leftButtonToRender, rightButtonToRender] = buttonsRender!([leftButton, rightButton]);

    // 兼容trigger=button模式使用tooltip场景，将内置样式加在leftButton上, 领域可以设置tagName=Tooltip
    let tooltipDisabed = false;
    if (
        React.isValidElement(leftButtonToRender) &&
		((leftButtonToRender as any)?.type?.displayName === 'Tooltip' || leftButtonToRender?.props?.tagName === 'Tooltip') &&
		(((leftButtonToRender?.props as any || {}).children as React.ReactElement) || {}).props?.className &&
		(leftButtonToRender.props as any)?.children.props.className.indexOf('wui-dropdown-button-left') !== -1
    ) {
        tooltipDisabed = true;
        leftButtonToRender = React.cloneElement(
            leftButtonToRender,
            {
                ...(leftButtonToRender.props || {}),
                // @ts-ignore
                children: React.cloneElement((leftButtonToRender.props as any).children as React.ReactElement, {
                    className: classNames(clsPrefix, className, `${clsPrefix}-no-line`),
                })
            },
        );
    }

    if (triggerType === 'button') {
        let adapterNid = getNid(props)
        return (
            <Dropdown {...finalProps} disabled={leftDisabled} trigger={trigger} {...adapterNid}>
                {React.cloneElement(leftButtonToRender as JSX.Element, {
                    style: style,
                    className: !tooltipDisabed ? classNames(clsPrefix, className, `${clsPrefix}-no-line`) : undefined,
                    ...adapterNid
                })}
            </Dropdown>
        )
    }

    let adapterNid = getNid(props)
    return (
        <ButtonGroup data-domid={rootNodeId} style={style} className={classNames(clsPrefix, className)} {...adapterNid}>
            {leftButtonToRender}
            <Dropdown
                {...finalProps}
                disabled={rightDisabled}
                trigger={trigger}
                domid={rootNodeId}
            >
                {rightButtonToRender as JSX.Element}
            </Dropdown>
        </ButtonGroup>
    );
}

export default WebUI({name: "dropdown-button"})(DropdownButton);